import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Attendance from "@/pages/Attendance";
import Leaves from "@/pages/Leaves";
import Payslips from "@/pages/Payslips";
import Commissions from "@/pages/Commissions";
import MyCommissions from "@/pages/MyCommissions";
import Employees from "@/pages/Employees";
import EmployeeProfile from "@/pages/EmployeeProfile";
import OrgChart from "@/pages/OrgChart";
import Profile from "@/pages/Profile";
import CompanySettings from "@/pages/CompanySettings";
import Recognition from "@/pages/Recognition";
import Announcements from "@/pages/Announcements";
import Documents from "@/pages/Documents";
import CalendarPage from "@/pages/CalendarPage";
import Performance from "@/pages/Performance";
import Suggestions from "@/pages/Suggestions";
import Inventory from "@/pages/Inventory";
import Claims from "@/pages/Claims";
import Directory from "@/pages/Directory";
import Platform from "@/pages/Platform";

const SuperGate = ({ children }) => {
  const { user } = useAuth();
  if (user?.platform_role === "super_admin" && !localStorage.getItem("act_tenant"))
    return <Navigate to="/platform" replace />;
  return children;
};
import { Loader2 } from "lucide-react";

const Protected = ({ children }) => {
  const { user, ready } = useAuth();
  if (!ready)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const PublicOnly = ({ children }) => {
  const { user, ready } = useAuth();
  if (!ready)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  if (user) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/platform" element={<Protected><Platform /></Protected>} />
            <Route
              element={
                <Protected>
                  <SuperGate>
                    <Layout />
                  </SuperGate>
                </Protected>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/attendance" element={<Attendance />} />
              <Route path="/leaves" element={<Leaves />} />
              <Route path="/payslips" element={<Payslips />} />
              <Route path="/commissions" element={<Commissions />} />
              <Route path="/my-commission" element={<MyCommissions />} />
              <Route path="/employees" element={<Employees />} />
              <Route path="/employees/:id" element={<EmployeeProfile />} />
              <Route path="/org-chart" element={<OrgChart />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/settings" element={<CompanySettings />} />
              <Route path="/recognition" element={<Recognition />} />
              <Route path="/announcements" element={<Announcements />} />
              <Route path="/documents" element={<Documents />} />
              <Route path="/calendar" element={<CalendarPage />} />
              <Route path="/performance" element={<Performance />} />
              <Route path="/suggestions" element={<Suggestions />} />
              <Route path="/inventory" element={<Inventory />} />
              <Route path="/claims" element={<Claims />} />
              <Route path="/directory" element={<Directory />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
